module.exports = __webpack_public_path__ + "static/media/calendarIcon.77c703c6.svg";